'use strict';
/* globals angular */

var DropdownButtonDirective = function () {
  function compile (tElem, attrs) {
    // we need access to the compile phase in order to dynamically alter the icon before it's rendered
    var button = angular.element(tElem[0].children[0].children[0].children[0]);
    button.attr('data-icon', attrs.icon);

    // the compile function must return a link function
    return link;
  }

  function link (scope, el, attrs, ctrl, transclude) {
    var container = angular.element(el[0].children[0].children[0]);

    container.append(transclude());
  }

  function DropdownController ($document, $scope, $window) {
    var INCLUDE = 'NG-INCLUDE';
    var SHOW_CLASS = 'show-content';
    var ARROW_CLASS = 'down-arrow';

    var isNgInclude = function isNgInclude (el) {
      return el.tagName === INCLUDE;
    };

    var toggle = function toggle (el, parent) {
      angular.element(el).toggleClass(SHOW_CLASS);
      angular.element(parent).toggleClass(ARROW_CLASS);
    };
    var hide = function hide (el, parent) {
      angular.element(el).removeClass(SHOW_CLASS);
      angular.element(parent).removeClass(ARROW_CLASS);
    };
    var destroy = function destroy (el, parent) {
      angular.element(el).remove();
      angular.element(parent).remove();
    };

    this.dropdownContent = null;
    this.button = null;

    this.showDropdown = function (e) {
      this.button = e.target;

      var nextElementSibling = this.button.nextElementSibling;
      // this check allows us to either code the transcluded menu element directly in between the dropdown-button elements or include it dynamically with ng-include
      this.dropdownContent = isNgInclude(nextElementSibling) ? nextElementSibling.childNodes[0] : nextElementSibling;

      // Prevent clicks inside dropdown content from closing the dropdown
      angular.element(this.dropdownContent).on('click', function (e) {
        e.stopPropagation();
      });

      toggle(this.dropdownContent, this.button);
    };

    // listen for clicks on the entire document and close the dropdown unless click is in dropdown
    $document.on('click', function (e) {
      if (this.button !== e.target) {
        hide(this.dropdownContent, this.button);
      }
    }.bind(this));

    $window.addEventListener('message', function (e) {
      if (e.data === 'close_share_dialog') {
        hide(this.dropdownContent, this.button);
      }
    }.bind(this));

    // garbage collect the onClick event listener when scope is destroyed
    $scope.$on('$destroy', function () {
      destroy(this.dropdownContent, this.button);
      this.dropdownContent = null;
      this.button = null;
    }.bind(this));
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    scope: {
      closeOnClick: '=',
      icon: '=',
      text: '='
    },
    compile: compile,
    controller: ['$document', '$scope', '$window', DropdownController],
    controllerAs: 'vm',
    templateUrl: 'dash/directives/dropdownButton.tpl.html',
    transclude: true
  };
};

module.exports = DropdownButtonDirective;



// WEBPACK FOOTER //
// ./src/app/dash/directives/DropdownButtonDirective.js